import styled from "styled-components";


export const ContainerLayout = styled.div`
  display: grid;
  height: 100%;
  width: 100%;
  flex-direction: column;
  row-gap: 5px;
  position: relative;
  overflow-y: scroll;
  box-sizing: border-box;
  grid-template-rows: 40px auto 1fr;
  padding: 0 10px;
`


export const ContainerGraficos = styled.div`
  padding: 5px 0;
  width: 100%;
  display: grid;
  border-radius: 5px;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(auto-fit, minmax(250px, 300px));
  justify-content: center;
  row-gap: 3px;
  column-gap: 3px;

  @media (max-width: 800px){
    & {
      grid-template-columns: 1fr;
    }
  }
`

export const ContainerFiltrosEActions = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
`

export const Grafico = styled.div`
        display: flex;
        max-height: 250px;
        padding: 5px;
        background-color: ${({ theme }) => theme.menu.main};
        border-radius: 8px;
        box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.3);
`

export const PainelExplicativo = styled.section`
    width: 100%;
    padding: 8px;
    gap: 0.5em;
    background-color: ${({ theme }) => theme.menu.main};
    border-radius: 5px;
    height: 100px;
    align-items: center;
    justify-content: center;
    font-size: large;
    display: flex;
    flex-direction: column;
    color: ${({ theme }) => theme.text};
    box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.5);
    z-index: 888;

    h1 {
      font-weight: 400;
    }

    div {
      font-weight: bold;
      font-size: x-large
    }

`

export const ContainerCardsExplicativos = styled.div`
  display: flex;
  top: 5px;
  flex-direction: column;
  gap: 0.3rem;

  @media (min-width: 700px) {
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    gap: 20px;
    align-items: center;
    justify-content: center;
  }
`
